import styled from "styled-components";
import { media } from "../../theme/theme";
import { H4 } from "../Typography";

export const ProgressBarContainer = styled.div<{ widthLength: number }>`
    max-width: 100vw;
    margin-left: 0;
    overflow-x: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding-top: 10px;
    display: flex;
    flex-wrap: nowrap;

    ${({ widthLength }) => `${media.custom(widthLength)} {
       overflow-x: initial;
       margin: 0 auto;
    }`}

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const ProgressBarWrapper = styled.div<{ widthLength: number, shrinkLength: number }>`
    display: flex;
    justify-content: space-between;
    position: relative;
    margin: 45px auto 0;
    padding: 0 16px;
    flex-shrink: 0;
    width: ${({ widthLength, shrinkLength }) => `${widthLength - shrinkLength}px`};

    ${({ widthLength }) => `${media.custom(widthLength)} {
       width: ${widthLength}px;
    }`}
`

export const PaginationSpacer = styled.div<{ widthLength: number, lastElementWidth: number }>`
    margin-right: ${({ lastElementWidth }) => `${lastElementWidth}px`};
    
    ${({ widthLength }) => `${media.custom(widthLength)} {
       display: none;
    }`}
`;

export const ProgressBarDot = styled.div<{ active: boolean }>`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transition: background .35s ease;
    background: ${({ active, theme }) => active ? theme.marketing.colors.dodgerBlue100 : "white"};
    border:  ${({ theme }) => `1px solid ${theme.marketing.colors.dodgerBlue100}`};
    position: relative;
    z-index: 1;

    &:hover {
        cursor: pointer;    
    }
`;

export const ProgressBarProgressWrapper = styled.div`
    height: 3px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    overflow: hidden;
    width: calc(100% - 32px);
`;

export const ProgressBarProgress = styled.div<{
    width: number,
    animationEnabled: boolean,
    activeIndex: number,
    transitionDuration: number,
    transitionDelay: number
}>`
    width: 100%;
    height: 2px;
    background: ${({ theme }) => theme.marketing.colors.dodgerBlue50};

    &:after {
        content: "";
        display: block;
        height: 3px;
        width: 100%;
        left: -100%;
        will-change: width;
        background: ${({ theme }) => theme.marketing.colors.dodgerBlue100};
        position: absolute;
        top: 50%;
        transform: ${({ width }) => `translate(${width}%, -50%);`}; 
        transition: ${({ animationEnabled, transitionDuration }) => animationEnabled ? `transform ${transitionDuration}ms linear` : null};
        transition-delay: ${({ activeIndex, transitionDelay, animationEnabled }) => {
        if (!animationEnabled) return null;
        return activeIndex > 0 ? `${transitionDelay}ms` : "0ms";
    }};
    }
`;

export const DotsWrapper = styled.div<{ active: boolean, widthLength: number }>`
    position: absolute;
    display: flex;
    align-items: center;
    bottom: 30px;
    left: -5px;

    ${({ widthLength }) => `${media.custom(widthLength)} {
        left: 50%;
        transform: translateX(-50%);
    }`}

    > div {
        &:first-child {
            display: inline-flex;
            margin-right: 10px;
        }
    }

    ${H4} {
        transition: color .35s ease;
        color: ${({ active, theme }) => active ? theme.marketing.colors.dodgerBlue100 : theme.marketing.colors.dodgerBlue70};
        display: block;
        font-size: 20px;
        line-height: 20px;
        max-width: 100px;
        white-space: break-spaces;
        position: absolute;
        top: 50%;
        left: 35px;
        transform: translateY(-50%);

        ${({ widthLength }) => `${media.custom(widthLength)} {
            font-size: 24px;
            max-width: initial;
            white-space: nowrap;
            line-height: 24px;
            left: initial;
            transform: none;
            position: initial;
            top: initial;
        }`}
    }
`;